import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import './EmailLink.sass'
import { useContext } from 'react'
import { AuthContext } from '../../../App'

function EmailLink() {
  return (
    <div className="EmailLink">
      <a href={`mailto:vahta.zapolyarje@yandex.ru`} className="EmailIcon">
        <Icon name="envelope" weight="solid" />
      </a>
      <div className="Content">
        <a href={`mailto:vahta.zapolyarje@yandex.ru`} className="Email">
          vahta.zapolyarje@yandex.ru
        </a>
        <span className="Description">Напишите нам</span>
      </div>
    </div>
  )
}

export default EmailLink
